import React from 'react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Input from '@mui/material/TextField';
import TranslationIds from '../../../commons/translationIds';

function renderCustomText (p) {
    const {
        fieldErrors,
        classes,
        // customValues,
        updateCustomValues,
        item,
        translateWithValues,
    } = p;

    function getLabel () {
        if (fieldErrors[item.name]) {
            return `${item.name}*`;
        }
        if (item.required) {
            return `${item.name}*`;
        }
        return item.name;
    }

    function getHelperText () {
        if (fieldErrors[item.name]) {
            return translateWithValues(TranslationIds.REGISTRATION_REQUIRED_FIELD, { label: item.name });
        }
        return '';
    }

    function inputClass () {
        if (fieldErrors[item.name]) {
            return classes.inputBaseError;
        }
        return classes.inputBase;
    }
    
    return (
        <Grid className={classNames(['ecal-reg-field-custom-field-enter-text', classes.fieldRoot])}>
            <span className={classNames(['ecal-input-label', classes.fieldLabel])}>
                {getLabel()}
            </span>

            <Input
                name={item.name}
                className={inputClass()}
                InputProps={{
                classes: {
                    underline: classes.InputUnderline,
                    input: classes.Input,
                },
                }}
                // value={customValues[item.name]}

                onChange={e => {
                    updateCustomValues({
                        [item.name]: e.target.value,
                    },
                    {
                        selector: `input[name="${item.name}"]`,
                        field: item.name,
                    });
                }}

                onBlur={(e) => {
                    updateCustomValues({
                        [item.name]: e.target.value,
                    });
                }}

                id={item.id}
                margin="normal"
                placeholder={item.name}
                type="text"
                fullWidth
                error={ fieldErrors[item.name] }
                helperText={ getHelperText() } 
                />
        </Grid>
    );
}

export default renderCustomText;